import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { VariablesConfig } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

export interface FormContext {
  variablesConfig: VariablesConfig
}

// Basic approval form structure shared between approvals node and detailed
// approval forms. This is kept here to avoid circular dependencies.

export const createNodeSidepanelSchema = (_formContext: FormContext) => {
  return z.object({
    nodeType: z.enum(['task', 'approvals', 'condition', 'trigger', 'conditionIf', 'conditionElse']),
    title: z.string().min(1, { message: i18n.t('workflows.task_form.validation.title_required') }),
    description: z
      .string()
      .min(1, { message: i18n.t('workflows.task_form.validation.description_required') }),
    nodeData: z.object({
      handlerType: z
        .string()
        .min(1, { message: i18n.t('workflows.task_form.validation.handler_type_required') }),
    }),
  })
}

// Type exports
export type NodeSidepanelSchema = z.infer<ReturnType<typeof createNodeSidepanelSchema>>
export type NodeSidepanelType = NodeSidepanelSchema['nodeType']
